import { ICreateChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/create/create_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateChecklistMaquinaEquipUseCase
 */

export class CreateChecklistMaquinaEquipUseCase implements ICreateChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    codigo?: string,
    revisao?: string,
    descricao?: string
  ): Promise<number> {
    return await this.repository.createChecklistMaquinaEquip(
      codigo,
      revisao,
      descricao
    );
  }
}
